import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import FormCheckbox from '../../../../semantic-ui/components/form-checkbox';
import { removeModalQuery } from '../../../../utils/removeModalQuery';
import { updateAutoparkTransportAllowAction } from '../../actions';

const ToggleCellWrapper = ({ rowData, columnId, onUpdateAutoparkTransportAllow }) => {
	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const autoparkId = query.get('id');

	const handleCheckboxChange = () => {
		onUpdateAutoparkTransportAllow({
			autoparkId,
			transportId: rowData.id,
			value: !rowData[columnId],
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	return <FormCheckbox toggle type="checkbox" checked={rowData[columnId]} onChange={handleCheckboxChange} />;
};

const mapDispatchToProps = {
	onUpdateAutoparkTransportAllow: updateAutoparkTransportAllowAction,
};

ToggleCellWrapper.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
	onUpdateAutoparkTransportAllow: PropTypes.func.isRequired,
};

const ToggleCell = connect(null, mapDispatchToProps)(ToggleCellWrapper);

export { ToggleCell };
